import { Location, LocationAudits } from '@shared/types'
import { apiJSON } from '@shared/utils/api/api.util'
import { useQuery } from 'react-query'

export function useCompaniesEvaluationProfileQuery() {
  const {
    data: companiesEvaluationProfiles,
    isLoading: areCompaniesProfilesLoading,
  } = useQuery<(Location & LocationAudits)[]>(
    `CompaniesEvaluationProfiles`,
    () => apiJSON(`CompaniesEvaluationProfiles`)
  )

  return { companiesEvaluationProfiles, areCompaniesProfilesLoading }
}
